export const sortPositions = (talentPoolName, positions) => {
  const seen = new Set()

  return positions
    .filter(({ providerId }) => {
      if (seen.has(providerId)) return false
      seen.add(providerId)

      return true
    })
    .sort(({ providerId, title }) =>
      title.toLowerCase().trim().includes(talentPoolName)
        ? -providerId
        : providerId
    )
}
